import React from 'react';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import { Background } from '@/app/(authenticated)/(marketplace)/_components/types';

export default function IconButtonBackground(props: IconButtonProps & { background?: Background }) {
  const { children, sx, background, ...rest } = props;
  const theme = useTheme();

  return (
    <IconButton
      sx={{
        // 26 is hex for 15% opacity
        border: `solid 1px ${background === 'dark' ? theme.palette.surfaceInverted.main : '#00000026'}`,
        '&:hover': { backgroundColor: `${theme.palette.surface.light}26` },
        width: '100%',
        aspectRatio: '1',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </IconButton>
  );
}
